import axios from 'axios';
import { useEffect, useState } from 'react';
import { fetchAnnouncements } from '../api/announcements';
import {
  AnnouncementApiParams,
  AnnouncementsApiResponse,
} from '../types/api/announcements';

const useFetchAnnouncements = ({
  search,
  page,
  page_size,
  id,
  is_email,
  is_sent,
  type,
}: AnnouncementApiParams) => {
  const [data, setData] = useState<AnnouncementsApiResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    const source = axios.CancelToken.source();

    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchAnnouncements({
          search,
          page,
          page_size,
          id,
          is_email,
          is_sent,
          type,
        });
        if (isMounted) {
          setData(response.data);
          setIsError(false);
          setError(null);
        }
      } catch (err) {
        if (isMounted) {
          setIsError(true);
          setError('Error fetching data');
          setData(null);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
      source.cancel('Component unmounted');
    };
  }, [page, page_size, id, is_email, is_sent, type, search]);

  return { data, isLoading, isError, error };
};

export default useFetchAnnouncements;
